import React from "react";
import { Table, Button, Confirm, Popup } from "semantic-ui-react";

const botones = [
  {
    key: 0,
    texto: "Completar Tarea",
    icono: "check",
    accion: "completar"
  },
  {
    key: 1,
    texto: "Editar Tarea",
    icono: "pencil",
    accion: "editar"
  },
  {
    key: 2,
    texto: "Borrar Tarea",
    icono: "trash",
    accion: "borrar"
  }
];

class FilaTareas extends React.Component {
  state = {
    style: {},
    verConfirm: false,
    showButtons: false
  };

  /*- Mouse Events -*/
  onMouseEnter = () =>
    this.setState({
      style: { backgroundColor: "lavenderblush" },
      showButtons: true
    });

  onMouseLeave = () => this.setState({ style: {}, showButtons: false });

  /*- Handlers -*/
  handleCompletar = () => this.props.handleCompletarTarea(this.props.datos.id);

  handleEditar = () => this.props.handleEditItem(this.props.datos.id);

  handleBorrar = () => this.setState(state => ({ verConfirm: true }));

  handleBorrarCancela = () => this.setState(state => ({ verConfirm: false }));

  handleBorrarConfirma = () => {
    this.setState({ verConfirm: false });
    this.props.handleBorrarItem(this.props.datos.id);
  };

  /*- Render Helpers -*/
  renderFechaCreacion = `${new Date(
    this.props.datos.timestamp
  ).toLocaleDateString()}`;

  renderFechaLimite = `${new Date(
    this.props.datos.fecha_limite
  ).toLocaleDateString()}`;

  renderBotones = botones.map(boton => (
    <Popup
      key={boton.key}
      content={boton.texto}
      trigger={
        <Button
          disabled={this.props.datos.completada}
          basic
          icon={boton.icono}
          circular
          onClick={
            boton.accion === "completar"
              ? this.handleCompletar
              : boton.accion === "editar"
                ? this.handleEditar
                : this.handleBorrar
          }
        />
      }
    />
  ));

  render() {
    console.log("render filatareas");

    return (
      <React.Fragment>
        <Table.Row
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          style={{ color: this.props.datos.completada ? "green" : null }}
        >
          <Table.Cell content={this.renderFechaCreacion} collapsing />
          <Table.Cell content={this.renderFechaLimite} collapsing />
          <Table.Cell content={this.props.datos.descripcion} />
          <Table.Cell collapsing>{this.renderBotones}</Table.Cell>
        </Table.Row>
        <Confirm
          open={this.state.verConfirm}
          onCancel={this.handleBorrarCancela}
          onConfirm={this.handleBorrarConfirma}
          header="Se va a eliminar la tarea"
          content="¿Desea continuar?"
          cancelButton="No"
          confirmButton="si"
        />
      </React.Fragment>
    );
  }
}

export default FilaTareas;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventasNuevaTarea/tablaTareas/FilaTareas.jsx